import { HalalSeal, OrnateDivider } from './KeralaDecor';
import './ZabihaPromise.css';

export default function ZabihaPromise() {
  return (
    <section className="zp">
      <div className="container zp__inner">
        <div className="zp__seal">
          <HalalSeal size={170} />
        </div>
        <div className="zp__copy">
          <span className="eyebrow-script">Our Halal Promise</span>
          <h2>Zabiha. Hand-cut. Honest.</h2>
          <p>
            Every cut at H2 Fresh is Zabiha: hand-slaughtered, prayer first, by certified
            halal vendors who meet our standards before they meet our customers. We hand-cut
            to order. We don't pre-package what we wouldn't put in our own pots.
          </p>
          <p>
            We restock all week so what's in the case today was on the truck this morning.
            Walk in, ask questions, and we'll show you exactly where it came from.
          </p>
          <ul className="zp__pills">
            <li>Halal Certified Vendors</li>
            <li>Hand-Cut to Order</li>
            <li>Restocked All Week</li>
            <li>Family Owned</li>
          </ul>
        </div>
      </div>
      <OrnateDivider />
    </section>
  );
}
